// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultChartPropsMappingSource.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { toJS } from 'mobx';

import { isEqual, get, getOr, omitBy, isNil, has } from 'lodash/fp';

export default (reportPartDetails, fieldStore) => {
  const reportPartContent = reportPartDetails.reportPartContent || {};

  const getProperties = key => {
    if (!key) {
      const properties = reportPartDetails && reportPartDetails.getReportPartProperties();
      const props = toJS(properties);
      return props;
    }

    return reportPartContent.getReportPartProperties(key);
  };

  return {
    hideByChartType(optName) {
      return !has(optName, reportPartContent.defaultOptionsByType);
    },

    isNotBuild() {
      return !reportPartContent.isBeingBuild;
    },

    isBeingBuild() {
      return reportPartContent.isBeingBuild;
    },

    getClassNameByChartStatus() {
      return reportPartContent.isBeingBuild ? 'chart-being-build' : 'chart-not-build';
    },

    getChartType() {
      return reportPartContent.chartType;
    },

    getBorder() {
      return {
        'izEntire.borderColor': getProperties('izEntire.borderColor'),
        'izEntire.borderWidth': getProperties('izEntire.borderWidth'),
        'izEntire.borderStyle': getProperties('izEntire.borderStyle')
      };
    },

    getValueByKey: getProperties
  };
};



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartGauge/Izenda.DefaultGaugePropsMappingSource.js